function initFormList() {
  function configureInstitutionDropDown(dropDown: HTMLSelectElement) {
    dropDown.addEventListener('change', () => {
      if (document.getElementsByName('page')[0] as HTMLInputElement) {
        ;(document.getElementsByName('page')[0] as HTMLInputElement).value = '1'
      }
      dropDown.form?.submit()
    })
  }
  const institutionDropDown = document.getElementById(
    'id_institution',
  ) as HTMLSelectElement
  configureInstitutionDropDown(institutionDropDown)
}

export { initFormList }
